



import Vue, { PropType } from "vue";
import { convertToTenThousand } from "@/features/home/utils";
import { SCALE_TYPE } from "@/features/home/enums";
import VueApexCharts from "vue-apexcharts";

type AuctionTimeChartData = {
  labels: string[];
  series: { name: string; data: number[] }[];
  colorList: string[];
};

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    series: [] as AuctionTimeChartData["series"],
    options: {},
  }),
  created() {
    this.updateData();
  },
  props: {
    chartData: { type: Object as PropType<AuctionTimeChartData> },
    scaleType: { type: String as PropType<typeof SCALE_TYPE[keyof typeof SCALE_TYPE]["value"]> },
  },
  methods: {
    updateData() {
      this.series = this.chartData.series;
      this.options = {
        chart: {
          type: "line",
          animations: {
            enabled: false,
          },
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
          curve: "smooth",
        },
        colors: this.chartData.colorList,
        labels: this.chartData.labels,
        legend: {
          position: "top",
          fontSize: "10px",
          markers: {
            width: 8,
            height: 8,
          },
        },
        markers: {
          size: 2,
          strokeWidth: 0,
          hover: {
            sizeOffset: 2,
          },
        },
        tooltip: {
          enabled: false,
        },
        grid: {
          borderColor: "#EAEAEA",
          yaxis: {
            lines: {
              show: true,
            },
          },
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        yaxis: {
          tickAmount: 6,
          title: {
            text: "Impression",
          },
          labels: {
            formatter: function (value: any) {
              if (value !== null) {
                return convertToTenThousand(value);
              } else {
                return "--";
              }
            },
          },
          forceNiceScale: true,
          logarithmic: this.scaleType === SCALE_TYPE.LOGARITHMIC.value,
          min: function (min: any) {
            // NOTE: 対数軸の際は最小値を設定しないとグラフがバグるため
            if (this.logarithmic) {
              return min;
            }
            return 0;
          },
        },

        xaxis: {
          title: {
            text: "AuctionTime Group",
          },
          labels: {
            style: { fontSize: "10px" },
          },
        },
      };
    },
  },
});
